import { createContext } from "react";

import { ISessionContext } from "../types";

export const SessionContext = createContext<ISessionContext | null>(null);
